import React, { useEffect, useState } from "react";
import { Box, Button, Card } from "@material-ui/core";
import ReactQuill from "react-quill";
import MTextField from "../../components/MTextField";
import { CameraAlt } from "@material-ui/icons";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { startLoading, stopLoading } from "../../actions/loadingAction";
import { errorSnackbar, successSnackbar } from "../../actions/snackbarActions";
import { Endpoint, Status } from "../../apis/apiConstants";
import AjaxHelper from "../../apis/apiRequest";
import placeholderBanner from "../../assets/Memon_Story.png";
import MFileUploadButton from "../../components/MFileUploadButton";
import { DrawerItemsKey } from "../../constants/appConstants";
import { isFieldEmpty } from "../../helpers/appFieldValidation";
import "react-quill/dist/quill.snow.css";
import "./addStories.scss";
import {
  reactQuillFormats,
  reactQuillModules,
} from "../../constants/constants.quill";

const AddStories = (props) => {
  const { state } = useLocation();
  const [content, setContent] = useState("");
  const [headline, setHeadline] = useState("");
  const [uploadedImage, setUploadedImage] = useState(placeholderBanner);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isFileUploaded, setIsFileUploaded] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (state?._id) {
      getStories(state?._id);
    }
  }, []);

  const getStories = (id) => {
    dispatch(startLoading);
    AjaxHelper.getApi(navigate, `${Endpoint.GET_STORIES}/${id}`)
      .then((response) => {
        dispatch(stopLoading);
        if (response.data.status === Status.API_SUCCESS) {
          console.log(response.data.data);
          setUploadedImage(response.data.data.imgUrl ?? placeholderBanner);
          setHeadline(response.data.data.headline);
          setContent(response.data.data.blog);
        } else {
          dispatch(errorSnackbar("Error while fetching Story."));
        }
      })
      .catch((err) => {
        dispatch(stopLoading);
        dispatch(errorSnackbar("Error while fetching Story."));
      });
  };

  const handleSave = () => {
    if (getValidation()) {
      dispatch(startLoading);
      if (isFileUploaded) {
        uploadFile();
      } else {
        if (state?._id) {
          updateStories();
        } else {
          addStoryApi();
        }
      }
    }
  };

  const getValidation = () => {
    let isValidated = true;
    if (isFieldEmpty(headline)) {
      dispatch(errorSnackbar("Please provide headline for the story"));
      isValidated = false;
    } else if (isFieldEmpty(content)) {
      dispatch(
        errorSnackbar("Please provide some amazing content for the story")
      );
      isValidated = false;
    }

    return isValidated;
  };

  const addStoryApi = (url) => {
    const params = {
      headline: headline,
      description: stripHTMLTags(content),
      blog: content,
      imgUrl: url,
    };
    AjaxHelper.postApi(navigate, Endpoint.ADD_STORIES, params)
      .then((response) => {
        dispatch(stopLoading);
        if (response.data.status === Status.API_CREATED) {
          dispatch(successSnackbar("Story added  successfully."));
          props.onPageChange(DrawerItemsKey.STORIES_SCREEN);
        } else {
          dispatch(errorSnackbar("Error while Adding Story."));
        }
      })
      .catch((err) => {
        dispatch(stopLoading);
        dispatch(errorSnackbar("Error while Adding Story."));
      });
  };

  const updateStories = (url) => {
    const params = {
      _id: state?._id,
      headline: headline,
      description: stripHTMLTags(content),
      blog: content,
      imgUrl: url,
    };
    AjaxHelper.postApi(navigate, Endpoint.UPDATE_STORIES, params)
      .then((response) => {
        console.log(params, "logging params");
        dispatch(stopLoading);
        if (response.data.status === Status.API_CREATED) {
          dispatch(successSnackbar("Story updated successfully."));
          navigate(-1);
        } else {
          dispatch(errorSnackbar("Error while updating the story."));
        }
      })
      .catch((err) => {
        dispatch(stopLoading);
        dispatch(errorSnackbar("Error while updating the story."));
      });
  };

  const uploadFile = () => {
    console.log(selectedFile);
    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("key", "stories");

    console.log(formData);

    AjaxHelper.uploadFile(navigate, Endpoint.UPLOAD_FILE, formData)
      .then((response) => {
        if (response.data.status === Status.API_SUCCESS) {
          if (state?._id) {
            updateStories(response.data.data.url);
          } else {
            addStoryApi(response.data.data.url);
          }
        } else {
          dispatch(stopLoading);
          dispatch(errorSnackbar("Error while Adding Stories."));
        }
      })
      .catch((err) => {
        dispatch(stopLoading);
        dispatch(errorSnackbar("Error while Adding Stories."));
      });
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    console.log(file);
    if (file) {
      setSelectedFile(file);
      setIsFileUploaded(true);
      const reader = new FileReader();
      reader.onloadend = () => {
        setUploadedImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const stripHTMLTags = (html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
  };

  return (
    <Box>
      <Card className="addStoriesCard">
        <Box className="addStoryContainer">
          <Box
            className="addStoryUploadPhoto"
            style={{
              backgroundImage: `url(${uploadedImage})`,
            }}
          >
            <MFileUploadButton icon={CameraAlt} onChange={handleImageUpload} />
          </Box>

          <Box className="addStoriesInput">
            <MTextField
              placeholder="addStoryHeadline"
              value={headline}
              onChange={(e) => setHeadline(e.target.value)}
            />

            <Box className="addStoryReactQuill">
              <ReactQuill
                className="addStoriesReactQuill"
                value={content}
                onChange={setContent}
                modules={{
                  toolbar: reactQuillModules,
                }}
                formats={reactQuillFormats}
                placeholder="Write something amazing..."
              />
            </Box>

            <Box className="addStoriesBtn">
              <Button
                variant="outlined"
                onClick={handleSave}
                style={{ backgroundColor: "#BCBF4E" }}
              >
                {state?._id ? "Update" : "Save"}
              </Button>
            </Box>
          </Box>
        </Box>
      </Card>
    </Box>
  );
};

export default AddStories;
